import { SelectedFilters } from '@/fo/ui/product/layout/catalog';

export function parseFiltersQuery(queryValue: unknown): SelectedFilters {
  if (!queryValue) return {};
  if (typeof queryValue === 'object') return queryValue as SelectedFilters;
  if (typeof queryValue === 'string') {
    const result = queryValue
      .split('&')
      .reduce<SelectedFilters>((acc, pair) => {
        const [rawKey, rawVal] = pair.split('=');
        if (!rawKey || rawVal === undefined) return acc;
        const val = decodeURIComponent(rawVal);
        acc[rawKey] = val.split(',');
        return acc;
      }, {});
    if (Object.keys(result).length === 0) return {};
    return result;
  }
  return {};
}

export function serializeFiltersQuery(value: SelectedFilters): string {
  return Object.entries(value)
    .filter(([, v]) => Boolean(v) && (!Array.isArray(v) || v.length > 0))
    .map(([key, v]) => {
      const val = Array.isArray(v) ? v.join(',') : v;
      return `${key}=${encodeURIComponent(String(val))}`;
    })
    .join('&');
}
